import { Navigate } from "@tanstack/react-router";

import { useEnableGoogleAdsIntegrationMilestone1 } from "@/features/google-ads/useEnableGoogleAdsIntegration";
import { GoogleAdsIntegrationPage } from "@/pages/applications/pages/googleAdsIntegration";

export const GoogleAdsIntegrationPageWrapper = () => {
  const enableGoogleAdsIntegration = useEnableGoogleAdsIntegrationMilestone1();

  if (!enableGoogleAdsIntegration) {
    return <Navigate to="/applications" replace />;
  }

  return <GoogleAdsIntegrationPage />;
};
